"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultColors = [
    'blue',
    'green',
    'yellow',
    'orange',
    'red',
    'purple',
    'lightBlue',
    'lightGreen',
    'lightYellow',
    'lightOrange',
    'lightRed',
    'lightPurple'
];
exports.default = defaultColors;
//# sourceMappingURL=defaultColors.js.map